module.exports = __webpack_public_path__ + "img/chocolate-thunder.b82ccaf3.png";